import { z } from 'zod';
import { ProdutoNcmStatus, ProdutoStatus, ProdutoTipo } from './enum';

export const ProdutoFieldsSchema = z.object({
    pro_altura: z.number().nullable(),
    pro_balanca_validade: z.literal(0).or(z.literal(1)).nullable(),
    pro_balanca_validade_dias: z.number().nullable(),
    pro_cbenef: z.string().nullable(),
    pro_cod_barra: z.string().nullable(),
    pro_codigo_interno: z.number(),
    pro_composicao: z.string().nullable(),
    pro_comprimento: z.number().nullable(),
    pro_controlar_estoque: z.literal(0).or(z.literal(1)).nullable(),
    pro_custo_medio: z.number(),
    pro_data_cadastro: z.string().nullable(),
    pro_data_remarcacao_custo: z.string().nullable(),
    pro_data_remarcacao_venda: z.string().nullable(),
    pro_data_ultima_compra: z.string().nullable(),
    pro_data_ultima_venda: z.string().nullable(),
    pro_descricao: z.string(),
    pro_empresa_idpk: z.number(),
    pro_estoque_minimo: z.number().nullable(),
    pro_exibir_catalogo: z.literal(0).or(z.literal(1)).nullable(),
    pro_favorito: z.literal(0).or(z.literal(1)),
    pro_fiscal_ceantrib: z.string().nullable(),
    pro_fiscal_qtrib: z.number(),
    pro_fiscal_utrib: z.string().nullable(),
    pro_fornecedor_idpk: z.number().nullable(),
    pro_gerar_sped: z.literal(0).or(z.literal(1)),
    pro_icmsstret_aliquota: z.number(),
    pro_icmsstret_base: z.number(),
    pro_icmsstret_fcp_aliquota: z.number(),
    pro_icmsstret_substituto: z.number(),
    pro_icmsstret_valor: z.number(),
    pro_idpk: z.number(),
    pro_inativo: z.enum(ProdutoStatus),
    pro_largura: z.number().nullable(),
    pro_lote_solicitar_venda: z.enum(['S', 'N']).nullable(),
    pro_marcadores: z.string().nullable(),
    pro_markup_minimo: z.number().nullable(),
    pro_markup_venda: z.number().nullable(),
    pro_ncm: z.string().nullable(),
    pro_ncm_descricao: z.string().nullable(),
    pro_ncm_status: z.enum(ProdutoNcmStatus).nullable(),
    pro_nota_fiscal_infadic: z.string().nullable(),
    pro_observacao: z.string().nullable(),
    pro_permite_estoque_negativo: z.literal(0).or(z.literal(1)).nullable(),
    pro_permite_mudar_preco: z.literal(0).or(z.literal(1)).nullable(),
    pro_permite_venda_fracionada: z.literal(0).or(z.literal(1)).nullable(),
    pro_peso_bruto: z.number().nullable(),
    pro_peso_liquido: z.number().nullable(),
    pro_preco_custo: z.number().nullable(),
    pro_preco_minimo: z.number().nullable(),
    pro_preco_venda: z.number().nullable(),
    pro_produto_anp_idpk: z.number().nullable(),
    pro_produto_categoria_idpk: z.number().nullable(),
    pro_produto_cest_codigo: z.string().nullable(),
    pro_produto_cest_descricao: z.string().nullable(),
    pro_produto_marca_idpk: z.number().nullable(),
    pro_produto_origem_codigo: z.number().nullable(),
    pro_produto_pai_idpk: z.number().nullable(),
    pro_produto_regra_fiscal_idpk: z.number().nullable(),
    pro_produto_tipo_codigo: z.string().nullable(),
    pro_produto_unidade_idpk: z.number().nullable(),
    pro_quantidade_fracao: z.number(),
    pro_sku: z.string().nullable(),
    pro_tipo: z.enum(ProdutoTipo),
    pro_ultima_alteracao: z.string(),
    pro_usa_balanca: z.literal(0).or(z.literal(1)),
    pro_video_url: z.string().nullable(),
    pro_volume_qtde: z.number(),
});

export type ProdutoFields = z.infer<typeof ProdutoFieldsSchema>;
